module.exports = __webpack_public_path__ + "static/media/logoALROTEK-01.4f25d66b.svg";